import React from 'react';
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { IconButton } from '@material-ui/core';
import ptBR from 'date-fns/locale/pt-BR';

export default function MonthPicker({ ...rest }) {
  const inputProps = {
    classes: {
      input: 'cursor-pointer',
    },
    endAdornment: (
      <IconButton aria-label="Select locale">
        <i className="las la-clock" />
      </IconButton>
    ),
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
      <TimePicker
        InputProps={inputProps}
        cancelLabel="Cancelar"
        clearable
        ampm={false}
        clearLabel="Limpar"
        classes={{
          root: 'w-100 w-lg-fit-content',
        }}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
}
